<template>
  <div>
    <v-card flat>
      <v-card-title class="text-h5 font-weight-bold">
        {{ $t('Properties') }}
      </v-card-title>

      <v-card-text>
        <v-form ref="form">
          <v-row>
            <v-col cols="12">
              <multi-property-picker
                v-model="formData.whitelist"
                :custom-listings="listings"
                :label="$t('Whitelisted Listings')"
                multiple
                :hide-btns="true"
                @input="updateForm"
              />

              <multi-property-picker
                v-model="formData.blacklist"
                :custom-listings="listings"
                :disabled="formData.whitelist.length !== 0"
                :label="$t('Blacklisted listings')"
                :hide-btns="true"
                @input="updateForm"
              />

              <multi-property-picker
                v-model="formData.featured_listings"
                :custom-listings="listings"
                :label="$t('Featured listings')"
                :max-items="9"
                :filter-listing-ids="filteredFeaturedListings"
                :hide-btns="true"
                @input="updateForm"
              />

              <v-col cols="12" sm="2" class="pa-0">
                <v-select
                  v-model="formData.location_filter_type"
                  :items="locationFilterOptions"
                  :label="$t('Location Filter Type')"
                  item-text="text"
                  item-value="value"
                  outlined
                  dense
                  class="mt-4"
                  @change="updateForm"
                />
              </v-col>
              <v-switch
                v-model="showFullAddress"
                class="mt-0"
                size="small"
                :label="$t('Show full address on website')"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import MultiPropertyPicker from 'components/multi-property-picker.vue'

export default {
  name: 'Properties',

  components: {
    MultiPropertyPicker,
  },

  props: {
    bookingEngineSetting: {
      type: Object,
      required: true,
    },
    listings: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      formData: {
        whitelist: this.bookingEngineSetting.whitelist || [],
        blacklist: this.bookingEngineSetting.blacklist || [],
        featured_listings: this.bookingEngineSetting.featured_listings || [],
        filter_by_region: this.bookingEngineSetting.filter_by_region || false,
        filter_by_neighborhood:
          this.bookingEngineSetting.filter_by_neighborhood || false,
        location_filter_type: this.getLocationFilterType(),
      },
    }
  },

  computed: {
    ...mapState('regions', ['regions']),

    locationFilterOptions() {
      return [
        { text: this.$t('city'), value: 'city' },
        { text: this.$t('Region'), value: 'region' },
        { text: this.$t('Neighborhood'), value: 'neighborhood' },
      ]
    },

    filteredFeaturedListings() {
      const { whitelist, blacklist } = this.formData
      const allListings = this.listings.map(listing => listing.id)
      let filtered = null
      if (whitelist.length) filtered = [...whitelist]
      if (blacklist.length)
        filtered = (filtered || allListings || []).filter(
          id => !blacklist.includes(id)
        )

      return filtered
    },
    showFullAddress: {
      get() {
        return this.bookingEngineSetting.custom_settings
          ? this.bookingEngineSetting.custom_settings.show_full_address
          : false
      },
      set(val) {
        if (!this.bookingEngineSetting.custom_settings) {
          this.$set(this.bookingEngineSetting, 'custom_settings', {
            show_full_address: val,
          })
        } else {
          this.bookingEngineSetting.custom_settings.show_full_address = val
        }
      },
    },
  },

  methods: {
    getLocationFilterType() {
      if (this.bookingEngineSetting.filter_by_neighborhood)
        return 'neighborhood'
      if (this.bookingEngineSetting.filter_by_region) return 'region'
      return 'city'
    },

    updateForm() {
      // Set boolean flags based on dropdown selection
      const updatedData = {
        ...this.formData,
        filter_by_region: this.formData.location_filter_type === 'region',
        filter_by_neighborhood:
          this.formData.location_filter_type === 'neighborhood',
      }
      this.$emit('update:setting', updatedData)
    },
  },
}
</script>
